import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title: string
  description: string
  path: string
  image?: string
  alternateMarkdownHref?: string
  jsonLd?: Record<string, unknown> | Record<string, unknown>[]
}

const SITE_URL = 'https://shimmertech.net'
const OG_IMAGE = `${SITE_URL}/og-image.png`

/**
 * Minimal SEO helmet for the v2 landing.
 * Renders title, description, canonical, OG, and optional JSON-LD per route.
 */
export default function SEO({ title, description, path, image, alternateMarkdownHref, jsonLd }: SEOProps) {
  const url = `${SITE_URL}${path}`
  const ogImage = image ? `${SITE_URL}${image}` : OG_IMAGE
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {alternateMarkdownHref && (
        <link rel="alternate" type="text/markdown" href={alternateMarkdownHref} />
      )}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="ShimmerTech" />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  )
}
